import { produce } from "immer";

export const ImmutableMapOperations = {
    set: <Key, Value>(set: ReadonlyMap<Key, Value>, key: Key, value: Value): ReadonlyMap<Key, Value> => {
        return produce<ReadonlyMap<Key, Value>, Map<Key, Value>>(set, (draft: Map<Key, Value>) => {
            draft.set(key, value);
            return draft;
        });
    },

    delete: <Key, Value>(set: ReadonlyMap<Key, Value>, key: Key): ReadonlyMap<Key, Value> => {
        return produce<ReadonlyMap<Key, Value>, Map<Key, Value>>(set, (draft: Map<Key, Value>) => {
            draft.delete(key);
            return draft;
        });
    },
};
